import { useContext, useEffect, useState, useRef } from "react";
import { Stepper, Step, StepLabel, Box, Grid, Button, Typography } from "@mui/material";
import { CheckoutOrders } from "./CheckoutOrder/CheckoutOrders";
import { CheckoutStep1 } from "./CheckoutSteps/CheckoutStep1";
import { CheckoutStep2 } from "./CheckoutSteps/CheckoutStep2";
import { CheckoutStep3 } from "./CheckoutSteps/CheckoutStep3";
import { CheckCircleOutline, Payment, DoneAll } from "@mui/icons-material";
import PropTypes from "prop-types";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import OrdersContext from "../../Context/Orders/OrdersContext";
import { useHistory } from "react-router-dom";
import { MethodPost } from "../../config/Service";
import CartContext from "../../Context/Cart/CartContext";
import AuthContext from "../../Context/auth/AuthContext";

const detailBlocks = [
  {
    step: "Paso 1",
    title: "Detalle de pedido",
    icon: <CheckCircleOutline />,
  },
  {
    step: "Paso 2",
    title: "Datos de pago",
    icon: <Payment />,
  },
  {
    step: "Paso 3",
    title: "Finalizar!",
    icon: <DoneAll />,
  },
];

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient(95deg, rgb(216,114,144) 0%, rgb(251, 193, 223) 50%, rgb(211,87,143) 100%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient(95deg, rgb(216,114,144) 0%, rgb(251, 193, 223) 50%, rgb(211,87,143) 100%)",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: "#D87390",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    ownerState.active || ownerState.completed ? "#F8BDD9" : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
}));

function ColorlibStepIcon(props) {
  const { active, completed, className, icon } = props;

  const icons = {
    1: <CheckCircleOutline />,
    2: <Payment />,
    3: <DoneAll />,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

export const Checkout = () => {
  const { clearCart } = useContext(CartContext);
  const { usuario } = useContext(AuthContext);
  const [activeStep, setActiveStep] = useState(0);
  const [direction, setDirection] = useState(null);
  const [helpSeller, setHelpSeller] = useState("");
  const [invoice, setInvoice] = useState("");
  const [cart, setCart] = useState(
    localStorage.getItem("cart") ? JSON.parse(localStorage.getItem("cart")) : []
  );
  const [total, setTotal] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [aditional, setAditional] = useState(0);
  const [coupon_id, setCouponId] = useState(null);
  const [shippingCost, setShippingCost] = useState(0);
  const [id_business, setIdBusiness] = useState(null);
  const { register, handleSubmit } = useForm();
  const [points, setPoints] = useState(0);
  const history = useHistory();

  // ── OpenPay state ────────────────────────────────
  const [paymentType, setPaymentType] = useState("transferencia");
  const [openPayLoading, setOpenPayLoading] = useState(false);
  const [sellerName, setSellerName] = useState(null);
  const openPayRef = useRef(null);

  const handleNext = () => {
    if (activeStep < detailBlocks.length - 1) {
      setActiveStep((prevStep) => prevStep + 1);
    }
  };

  const handlePrev = () => {
    if (activeStep > 0) {
      setActiveStep((prevStep) => prevStep - 1);
    }
  };
  const handleOrderCreation = async (data) => {
    try {
      console.log(data, "la data que se envia");

      const url = "/distribucion/Sales";

      Swal.fire({
        title: data.payment_type === "openpay"
          ? "Procesando pago..."
          : "Creando orden...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => Swal.showLoading(),
      });

      const response = await MethodPost(url, data);

      // ── 3D Secure: redirigir al banco ──────────────────
      if (response?.data?.needs_3ds && response?.data?.redirect_url) {
        Swal.fire({
          title: "Verificación bancaria",
          text: "Serás redirigido a tu banco para verificar el pago...",
          icon: "info",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          // Limpiar carrito antes del redirect (la venta ya se creó en pending_3ds)
          clearCart();
          localStorage.removeItem("cart");
          localStorage.removeItem("appliedCoupon");
          // Redirigir al banco
          window.location.href = response.data.redirect_url;
        });
        return;
      }

      if (response?.status === 200) {
        const successMsg = data.payment_type === "openpay"
          ? "¡Pago con tarjeta procesado exitosamente!"
          : "Tu compra se ha realizado con éxito. Ahora sube tu comprobante de pago.";

        Swal.fire({
          title: "¡Éxito!",
          text: successMsg,
          icon: "success",
          timer: 3500,
          showConfirmButton: false,
        }).then(() => {
          if (response.data.client) {
            localStorage.setItem(
              "updatedClient",
              JSON.stringify(response.data.client)
            );
          }
          setActiveStep(2);
          clearCart();
          localStorage.removeItem("cart");
          localStorage.removeItem("appliedCoupon");
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "La orden no pudo completarse. Intenta de nuevo.",
          icon: "error",
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.error("Error al crear la orden:", error);
      setOpenPayLoading(false);

      // Errores específicos de OpenPay
      const errorData = error.response?.data;
      let errorMsg = "Ocurrió un error al procesar tu orden.";

      if (errorData?.openpay_error) {
        errorMsg = errorData.error || "Tu tarjeta fue rechazada.";
      } else if (errorData?.error) {
        errorMsg = errorData.error;
      } else if (errorData?.message) {
        errorMsg = errorData.message;
      }

      Swal.fire({
        title: errorData?.openpay_error ? "Pago rechazado" : "Error",
        text: errorMsg,
        icon: "error",
        showConfirmButton: true,
      });
    }
  };

  const validateOrder = () => {
    if (!direction) {
      Swal.fire({
        title: "Cuidado",
        text: "Debes seleccionar una dirección de envío.",
        icon: "warning",
        timer: 2500,
        showConfirmButton: false,
      });
      return false;
    }

    if (!helpSeller) {
      Swal.fire({
        title: "Cuidado",
        text: "Indica si recibiste ayuda de un vendedor.",
        icon: "warning",
        timer: 1800,
        showConfirmButton: false,
      });
      return false;
    }

    if (!invoice) {
      Swal.fire({
        title: "Atención",
        text: "Selecciona si necesitas factura.",
        icon: "warning",
        timer: 1800,
        showConfirmButton: false,
      });
      return false;
    }

    return true;
  };

  const onSubmit = async (formData) => {
    // Función para calcular todos los valores del pedido
    const calculateOrderTotals = () => {
      let subtotalOriginal = 0;
      let descuentoDirecto = 0;
      let subtotalSinDescuentoDirecto = 0;
      let subtotalConDescuentoDirecto = 0;

      cart?.forEach((item) => {
        const precioOriginal = item.price * item.cantidad;
        subtotalOriginal += precioOriginal;

        // Si el producto tiene descuento directo (price_with_discount)
        if (item.price_with_discount > 0) {
          const precioConDescuentoDirecto =
            item.price_with_discount * item.cantidad;
          descuentoDirecto += precioOriginal - precioConDescuentoDirecto;
          subtotalConDescuentoDirecto += precioConDescuentoDirecto;
        } else {
          // Si no tiene descuento directo, se incluye en productos aplicables para reglas/cupón
          subtotalSinDescuentoDirecto += item.final_price;
        }
      });

      return {
        subtotalOriginal,
        descuentoDirecto,
        subtotalSinDescuentoDirecto,
        subtotalConDescuentoDirecto,
      };
    };

    // Calcular totales
    const totals = calculateOrderTotals();

    // Calcular descuentos aplicados
    const descuentoReglas =
      totals.subtotalSinDescuentoDirecto * (discount / 100);
    const subtotalDespuesReglas =
      totals.subtotalSinDescuentoDirecto - descuentoReglas;
    const descuentoCupon = subtotalDespuesReglas * (couponDiscount / 100);

    // Calcular total final
    const totalFinal =
      totals.subtotalConDescuentoDirecto +
      subtotalDespuesReglas -
      descuentoCupon;

    // Construir orderData con la lógica corregida
    const orderData = {
      ...formData,
      status: 0,

      // Subtotal original (precio base × cantidad de todos los productos)
      subtotal: totals.subtotalOriginal,

      // ID de regla de negocio aplicada
      id_business_rule: id_business,

      // Costo de envío
      shippingCost,

      // Descuento adicional por cupón (porcentaje del cupón)
      aditional_discount: aditional,

      // Total final calculado correctamente
      total: totalFinal,

      // Información adicional del pedido
      direction_id: direction,
      help_for_seller: helpSeller,
      seller: sellerName || null,
      invoice,

      // Lista de productos
      products_list: cart,

      // ID del cupón aplicado
      coupon_id: coupon_id,

      // Puntos utilizados por el usuario
      point_user: 0,

      // Puntos generados por esta compra
      points_generated: points,

      // ── Tipo de pago ─────────────────────────────────
      payment_type: paymentType,
    };

    if (!validateOrder()) return;

    // ── Pago con tarjeta: tokenizar y enviar ──────────
    if (paymentType === "openpay") {
      if (!openPayRef.current) {
        Swal.fire({
          title: "Error",
          text: "El formulario de pago no está disponible. Recarga la página.",
          icon: "error",
        });
        return;
      }

      setOpenPayLoading(true);
      try {
        const tokenData = await openPayRef.current.tokenize();
        orderData.token = tokenData.token;
        orderData.device_session_id = tokenData.device_session_id;
        handleOrderCreation(orderData);
      } catch (err) {
        setOpenPayLoading(false);
        Swal.fire({
          title: "Error en los datos de tarjeta",
          text: err.message || "Revisa los datos de tu tarjeta.",
          icon: "error",
        });
      }
      return;
    }

    // ── Transferencia: enviar directo ─────────────────
    setOpenPayLoading(true);
    handleOrderCreation(orderData);
    localStorage.removeItem("cart");
    localStorage.removeItem("appliedCoupon");
  };

  return (
    <Box sx={{ minHeight: "100vh", pb: 4 }}>
      {/* ─── Stepper Sticky ──────────────────────────────── */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 100,
          background: "rgba(255,255,255,0.92)",
          backdropFilter: "blur(12px)",
          borderBottom: "1px solid #F3CDD4",
          pt: 2,
          pb: 2,
          mb: 2,
        }}
      >
        <Stepper
          alternativeLabel
          activeStep={activeStep}
          connector={<ColorlibConnector />}
        >
          {detailBlocks.map((block, index) => (
            <Step key={index}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>
                <Typography
                  variant="caption"
                  sx={{
                    fontWeight: activeStep === index ? 700 : 500,
                    color: activeStep >= index ? "#801F56" : "#9e9e9e",
                    fontSize: { xs: "0.65rem", sm: "0.75rem" },
                  }}
                >
                  {block.title}
                </Typography>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>

      {/* ─── Layout principal ────────────────────────────── */}
      <Box sx={{ px: { xs: 1, sm: 2, md: 3 } }}>
        <Grid container spacing={3}>
          {/* Lado izquierdo — Scrolleable */}
          <Grid item xs={12} md={5}>
            {activeStep === 0 && (
              <CheckoutStep1
                onNext={handleNext}
                setDirection={setDirection}
                direction={direction}
              />
            )}
            {activeStep === 1 && (
              <CheckoutStep2
                onNext={handleNext}
                onPrev={handlePrev}
                helpSeller={helpSeller}
                setHelpSeller={setHelpSeller}
                invoice={invoice}
                setInvoice={setInvoice}
                paymentType={paymentType}
                setPaymentType={setPaymentType}
                openPayRef={openPayRef}
                setSellerName={setSellerName}
              />
            )}
            {activeStep === 2 && <CheckoutStep3 />}

            {/* ─── Botones de navegación ────────────────────── */}
            <Box
              sx={{
                mt: 3,
                mb: 2,
                display: "flex",
                justifyContent: activeStep === 1 ? "center" : "space-between",
                alignItems: "center",
                gap: 2,
                px: 2,
              }}
            >
              {activeStep === 0 && (
                <>
                  <Button
                    variant="outlined"
                    onClick={() => history.push("/Carrito-compras")}
                    sx={{
                      borderColor: "#E46EA7",
                      color: "#801F56",
                      "&:hover": {
                        borderColor: "#801F56",
                        background: "#FFF0F5",
                      },
                      borderRadius: 2.5,
                      px: 3,
                      py: 1.2,
                      fontWeight: 600,
                      textTransform: "none",
                      fontSize: "0.95rem",
                    }}
                  >
                    ← Volver al carrito
                  </Button>

                  <Button
                    variant="contained"
                    onClick={handleNext}
                    sx={{
                      background:
                        "linear-gradient(135deg, #801F56 0%, #D87390 100%)",
                      "&:hover": {
                        background:
                          "linear-gradient(135deg, #6B1A48 0%, #A93B7A 100%)",
                      },
                      borderRadius: 2.5,
                      px: 4,
                      py: 1.2,
                      fontWeight: 700,
                      textTransform: "none",
                      fontSize: "0.95rem",
                      boxShadow: "0 4px 16px rgba(128, 31, 86, 0.3)",
                      transition: "all 0.25s ease",
                      "&:active": { transform: "scale(0.97)" },
                    }}
                  >
                    Continuar al pago →
                  </Button>
                </>
              )}

              {activeStep === 1 && (
                <Box
                  component="form"
                  onSubmit={handleSubmit(onSubmit)}
                  noValidate
                  sx={{
                    display: "flex",
                    gap: 2,
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={handlePrev}
                    sx={{
                      borderColor: "#E46EA7",
                      color: "#801F56",
                      "&:hover": {
                        borderColor: "#801F56",
                        background: "#FFF0F5",
                      },
                      borderRadius: 2.5,
                      px: 3,
                      py: 1.2,
                      fontWeight: 600,
                      textTransform: "none",
                      fontSize: "0.95rem",
                    }}
                  >
                    ← Anterior
                  </Button>

                  <Button
                    variant="contained"
                    type="submit"
                    disabled={openPayLoading}
                    sx={{
                      background:
                        paymentType === "openpay"
                          ? "linear-gradient(135deg, #801F56 0%, #E46EA7 100%)"
                          : "linear-gradient(135deg, #801F56 0%, #D87390 100%)",
                      "&:hover": {
                        background:
                          paymentType === "openpay"
                            ? "linear-gradient(135deg, #6B1A48 0%, #D87390 100%)"
                            : "linear-gradient(135deg, #6B1A48 0%, #A93B7A 100%)",
                      },
                      "&:disabled": {
                        background: "#e0e0e0",
                        color: "#9e9e9e",
                      },
                      borderRadius: 2.5,
                      px: 4,
                      py: 1.4,
                      fontWeight: 700,
                      textTransform: "none",
                      fontSize: "1rem",
                      boxShadow: openPayLoading
                        ? "none"
                        : "0 6px 20px rgba(128, 31, 86, 0.35)",
                      transition: "all 0.25s ease",
                      "&:active": { transform: "scale(0.97)" },
                      minWidth: 200,
                    }}
                  >
                    {openPayLoading
                      ? "⏳ Procesando..."
                      : paymentType === "openpay"
                        ? "💳 Pagar con tarjeta"
                        : "✅ Finalizar compra"}
                  </Button>
                </Box>
              )}
            </Box>
          </Grid>

          {/* Lado derecho — Sticky en desktop */}
          <Grid item xs={12} md={7}>
            <Box
              sx={{
                position: { md: "sticky" },
                top: { md: 90 },
                maxHeight: { md: "calc(100vh - 100px)" },
                overflowY: { md: "auto" },
                "&::-webkit-scrollbar": { width: 6 },
                "&::-webkit-scrollbar-thumb": {
                  borderRadius: 3,
                  background: "#F3CDD4",
                },
              }}
            >
              <CheckoutOrders
                usuario={usuario}
                total={total}
                setTotal={setTotal}
                discount={discount}
                setDiscount={setDiscount}
                couponDiscount={couponDiscount}
                setCouponDiscount={setCouponDiscount}
                shippingCost={shippingCost}
                setShippingCost={setShippingCost}
                setAditional={setAditional}
                setCouponId={setCouponId}
                id_business={id_business}
                setIdBusiness={setIdBusiness}
                helpSeller={helpSeller}
                setHelpSeller={setHelpSeller}
                invoice={invoice}
                setInvoice={setInvoice}
                cart={cart}
                setCart={setCart}
                setPoints={setPoints}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

